export default "__VITE_ASSET__J1$$cTdk__"